module.exports = __webpack_public_path__ + "assets/flywheel.8a3e0327.svg";